import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';

import { AuthInterceptor } from './auth.service';
import { GraphQLResponseInterceptor } from './forbidden-interceptor';

@NgModule({
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: GraphQLResponseInterceptor,
      multi: true
    }
  ]
})
export class AuthInterceptorModule { }
